import React, { useCallback, useRef, useState } from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { Button, Divider, Form, Input, message, Modal, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import MaxWill from '../dsMain/maxWill/maxWill';
import Util from '../../script/util';

const ComponentContent = (props) => {
  const { base, visible, orderInfo, submit, hideModal: propsHideModal } = props;
  const { uid, token, rootConfig } = base;
  const [form] = Form.useForm();
  const { resetFields, getFieldDecorator, validateFields } = form;
  const maxWillElement = useRef(null);
  const [fileList, setFileList] = useState([]);
  const [reasonDesc, setReasonDesc] = useState('');

  const hideModal = () => {
    resetFields();
    setReasonDesc('');
    setFileList([]);
    propsHideModal();
  };

  const onSubmit = (values) => {
    delete values.serviceTime;
    let images = [];
    fileList.forEach((item) => {
      if (item.response.code === 200) {
        images.push(item.response.data.default);
      }
    });
    if (!images?.length) {
      message.error('请检查图片是否上传成功');
      return;
    }
    values.reasonImg = images.join(',');

    const params = {
      uid,
      orderId: orderInfo.orderId,
      ...values,
    };

    submit(params, () => {
      hideModal();
    });
  };

  // 图片预览
  const handlePreview = async (file) => {
    let index = 0;
    let images = [];
    for (let i = 0; i < fileList.length; i++) {
      const item = fileList[i];
      if (item.uid === file.uid) {
        index = i;
      }
      images.push(item?.response?.data?.default || null);
    }
    maxWillElement.current.showModal(images, index);
  };
  // 上传图片之前
  const beforeUpload = (file) => {
    return new Promise((resolve, reject) => {
      if (file.size > 1024 * 1024 * 2) {
        message.error(`上传失败，图片大小不能超过${2}MB`);
        reject(false);
      }
      resolve(true);
    });
  };
  const onChangeUpload = (info) => {
    const { file, fileList } = info;

    if (file.status === 'uploading') {
      // setLoading(true);
    } else if (info.file.status === 'done') {
      const res = info.file.response;
      if (res.code !== 200) {
        fileList.pop();
        message.error((res && res.message) || '上传失败，请稍候重试');
      }
      // setLoading(false);
    } else if (info.file.status === 'error') {
      message.error('上传失败，请稍后重试~');
      // setLoading(false);
    }
    setFileList(fileList);
  };

  // 维权原因填写，用于计数
  const onChangeReason = useCallback((e) => {
    setReasonDesc(e.target.value ? e.target.value.trim() : '');
  }, []);

  // 上传图片 DOM
  const renderUploadButton = (
    <div className="uploader">
      <PlusOutlined />
    </div>
  );

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
  };

  return (
    <>
      <Modal
        open={visible}
        title="维权申请"
        wrapClassName="daidai-modal-style has-top-border order-appeal-modal"
        centered
        footer={null}
        keyboard={false}
        maskClosable={false}
        onCancel={hideModal}
        width={600}
        zIndex={1002}
      >
        {!!orderInfo && (
          <Form
            form={form}
            className="appeal-form"
            onFinish={onSubmit}
            autoComplete="off"
            {...layout}
          >
            <Form.Item label="订单信息" className="order-info-form">
              <div className="form-value order-info">
                <div className="cover">
                  <img
                    src={Util.transImgUrl(
                      orderInfo?.categoryIcon || null,
                      '28x28'
                    )}
                    alt={orderInfo.categoryName}
                  />
                </div>
                <p className="name">{orderInfo.categoryName}</p>
                <p className="price red-txt">{orderInfo.totalDiamond}钻</p>
                <p className="coupon red-txt">
                  (优惠券抵扣{orderInfo.discountDiamond}钻)
                </p>
              </div>
            </Form.Item>
            <Form.Item label="订单号">
              <div className="form-value">{orderInfo.orderId}</div>
            </Form.Item>
            <Form.Item label="订单时长">
              <div className="form-value">
                <span className="red-txt">
                  {orderInfo.viewUnitNum}
                  {orderInfo.viewUnit}
                </span>
              </div>
            </Form.Item>
            <Form.Item label="开始服务时间">
              <div className="form-value">
                {dayjs(orderInfo.orderBeginTime).format('YYYY-MM-DD HH:mm:ss')}
              </div>
            </Form.Item>
            <Form.Item label="实际服务时长">
              <div className="form-value">
                <span className="red-txt">
                  {orderInfo.actualServiceTime}
                  {orderInfo.viewUnit}
                </span>
              </div>
            </Form.Item>
            <Form.Item label="申请退款金额">
              <div className="form-value">
                <span className=" red-txt">{orderInfo.refundDiamond}钻</span>
              </div>
            </Form.Item>
            <Divider type="horizontal" />
            <Form.Item label="申诉理由" className="form-fill-in" required>
              <Form.Item
                name="reason"
                rules={[
                  { required: true, message: '请填写你的维权理由' },
                  { max: 50, message: '最多50个字' },
                ]}
              >
                <Input.TextArea
                  placeholder="填写你的维权理由"
                  style={{ width: 356 }}
                  onChange={onChangeReason}
                />
              </Form.Item>
              <p className="reason-count">{reasonDesc?.length || 0}/50</p>
            </Form.Item>
            <Form.Item
              label="上传凭证"
              className="form-fill-in"
              rules={[{ required: true, message: '请上传凭证' }]}
            >
              <p className="prefix-txt">
                请上传完整聊天记录、通话时长、对局信息等，最多九张图片
              </p>
              <Upload
                action={`${rootConfig.ctxPath}/file/api/base/upload`}
                headers={{
                  authorization: token,
                  uid: uid,
                }}
                listType="picture-card"
                showUploadList={true}
                fileList={fileList}
                onPreview={handlePreview}
                beforeUpload={beforeUpload}
                onChange={onChangeUpload}
              >
                {fileList.length >= 9 ? null : renderUploadButton}
              </Upload>
            </Form.Item>
            <Form.Item
              label="QQ"
              className="form-fill-in"
              name="qq"
              rules={[
                {
                  required: rootConfig.lang === 'zh_CN',
                  message: '请填写你的QQ方便客服联系',
                },
                {
                  pattern: /^[0-9]*$/,
                  message: '请正确填写你的QQ方便客服联系',
                },
              ]}
            >
              <Input placeholder="填写你的QQ号" style={{ width: 280 }} />
            </Form.Item>
            <Form.Item
              label="手机"
              className="form-fill-in"
              name="phone"
              rules={[
                {
                  required: rootConfig.lang === 'zh_CN',
                  message: '请填写你的手机号码方便客服联系',
                },
                {
                  pattern:
                    /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
                  message: '请正确填写你的手机号码方便客服联系',
                },
              ]}
            >
              <Input placeholder="填写你的手机号" style={{ width: 280 }} />
            </Form.Item>

            <Form.Item className="form-footer">
              <Button className="daidai-btn" onClick={hideModal}>
                取消
              </Button>
              <Button className="daidai-btn-primary" htmlType="submit">
                确定
              </Button>
            </Form.Item>
          </Form>
        )}
      </Modal>
      {/* 图片预览 */}
      <MaxWill wrappedComponentRef={maxWillElement} />
    </>
  );
};

export default connect((store) => ({ base: store }))(ComponentContent);
